module.exports = __webpack_public_path__ + "img/文字_E级赛事@3x.288adc55.png";